export const HOME_PAGE = '/'
export const DETECT_PAGE = '/detect'